<section class="flex justify-between items-center mb-3">
    <h1 class="text-2xl font-bold text-gray-800">Registro de actividad</h1>
</section>

<sau-table #sauTable [url]="url" [filterConfig]="filterConfig" contentList="list" contentTotal="total"
    pageParamName="page" limitParamName="limit" [sizeInitialPage]="1" [sizeBetweenPages]="1" [limit]="20"
    [headers]="headers" [showOptions]="false"></sau-table>
